import './app.css';
import { mount } from 'svelte';
import App from './App.svelte';
import { installExternalLinkInterceptor } from './lib/native/capacitorBridge';

// Shell nativa iOS: i link esterni devono aprire il browser di sistema,
// non caricare dentro la webview. No-op ovunque altro.
installExternalLinkInterceptor();

const target = document.getElementById('app');
if (!target) throw new Error('Missing #app mount point');

const app = mount(App, { target });

export default app;
